import React from "react";
import bgHero from "../assets/bgHero.jpg";
// import { FaPlay } from "react-icons/fa";
// import { GrAdd } from "react-icons/gr";
// import { AiFillStar, AiOutlineStar, AiFillHeart } from "react-icons/ai";
// import { IoMdCloudDownload } from "react-icons/io";
const Hero = () => {
  return (
    <div className="w-full h-screen flex flex-col mx-auto " name="home">
      <img src={bgHero} alt="" className="w-full h-screen object-cover " />
      <div className="absolute w-full h-full top-0 left-0 bg-gray-900/70"></div>
      <div className="absolute  bottom-10 text-white md:left-12 sm:left-2 justify-center items-center">
        <div className="flex flex-col justify-center md:items-start  mx-3  text-white ">
          <h4 className="py-3 text-3xl md:text-4xl font-sans ">
            WELCOME TO HANGAR MOVIE
          </h4>
          <div className="mx-auto py-4 grid sm:grid-cols-1  lg:grid-cols-2">
            <p className="mr-2 text-xl font-sans">
              Hangar Movie has an excellent collection of original videos as
              well as movies and shows from other sources. You can either rent
              or buy your favorite movies and watch them offline.
            </p>
          </div>
          <div className="flex">
            <button className="py-3 px-6 flex my-4 items-center mr-3 rounded-[10px] bg-gradient-to-r from-[var(--primary-dark)] to-[var(--primary-light)] md:text-xl text-[15px]">
              Get Started
            </button>
          </div>
          <div className="flex  mx-3">
            <p className="mr-2 text-gray-300">
              Membership renews at $ 5.99 +/month.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
